import script from "./alumni.vue?vue&type=script&setup=true&lang=js"
export * from "./alumni.vue?vue&type=script&setup=true&lang=js"

import "./alumni.vue?vue&type=style&index=0&id=570aeead&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-570aeead"]])

export default __exports__